import { log } from "../../";

import * as React from "react";
import { observer, inject } from "mobx-react";

// Material UI
import Paper from "@material-ui/core/Paper";

// Custom UI
import CircularProgress from "@material-ui/core/CircularProgress";

// Stores
import { AudioStore } from "stores/AudioStore";

// Utils
import { Colors } from "core/utils/Colors";
import { Fonts } from "core/utils/Fonts";
import { RootStore } from "stores";
import { WithDivSizeProps } from "core/utils/withDivSize";

// Layout
import { Row, Col } from "layout";

export const DEFAULT_HEIGHT = 200;
export const DEFAULT_FONT_SIZE = 15;
export const QUESTION_FONT_SIZE = 13;

const onTextClicked = (audio: string, audioStore: AudioStore, event: any) => {
    event.stopPropagation();
    if (audio !== undefined && audioStore != undefined) {
        audioStore.playSound(audio);
    }
};

export const renderTextOnlyLine = (text: string, fontSize: number) => {
    if (text === undefined) {
        return null;
    }

    return (
        <Row center="xs" middle="xs">
            <div style={{ fontSize: fontSize, padding: fontSize / 2 }}>{text}</div>
        </Row>
    );
};

export const renderLine = (text: string, audioStore: AudioStore, audio: string, fontSize: number) => {
    if (text === undefined) {
        return null;
    }

    return (
        <Row center="xs" middle="xs">
            <div
                style={{ cursor: "pointer", fontSize: fontSize, padding: fontSize / 10 }}
                onTouchEnd={onTextClicked.bind(this, audio, audioStore)}
                onClick={onTextClicked.bind(this, audio, audioStore)}
            >
                {text}
            </div>
        </Row>
    );
};

export const renderImage = (image: string, imageHeight: number) => {
    if (image === undefined) {
        log.verbose("Clear image");
        return null;
    }

    let imageInProgress = image === "inProgress";
    if (imageInProgress) {
        return (
            <Row center="xs">
                <CircularProgress size={25} />
            </Row>
        );
    } else {
        return (
            <Row center="xs" middle="xs">
                <img
                    src={image}
                    style={{ paddingTop: 5, paddingBottom: 5, maxWidth: imageHeight, maxHeight: imageHeight }}
                />
            </Row>
        );
    }
};

export const calculateSizes = (
    originalCardHeight: number,
    originalCardWidth: number | String,
    originalFontSize: number
) => {
    let newHeight: number;
    let newWidth: number;
    // let newFontSize: number;

    let newStyles: any = {
        font: { fontFamily: Fonts.BalsamiqSans },
        card: { position: "relative", width: "100%" },
    };

    // Height
    newHeight = (originalCardHeight === undefined ? DEFAULT_HEIGHT : originalCardHeight) as number;
    newStyles.card.minHeight = newHeight;

    // Width
    if (originalCardWidth && (originalCardWidth instanceof String || typeof originalCardWidth === "string")) {
        newStyles.card.width = originalCardWidth as string;
    } else {
        if (originalCardWidth) {
            newWidth = originalCardWidth as number;
        } else {
            newWidth = (newHeight * 8) / 3;
        }
        newStyles.card.width = newWidth;
    }

    // Font size
    // let fontSize = originalFontSize;
    // if (!fontSize) {
    //     fontSize = Math.floor(newHeight / 8);
    // }
    // let fontMultiplier = fontSize / DEFAULT_FONT_SIZE;
    // newStyles.font.fontSize = fontSize * fontMultiplier;

    return { baseStyles: newStyles, height: newHeight, width: newWidth ? newWidth : newStyles.card.width };
};

export interface CategoryItemCardContainerProps extends WithDivSizeProps {
    cardWidth?: number | string;
    cardHeight?: number;
    fontSize?: number;
    backgroundColor?: string;
    onCardClicked?: (event: Event) => void;
    children?: any;
    isSelectable?: boolean;
    isSelected?: boolean;
    rootStore?: RootStore;
}

@inject("rootStore")
@observer
export default class CategoryItemCardContainer extends React.Component<CategoryItemCardContainerProps> {
    protected baseStyles: any;
    protected cardHeight: number;
    protected cardWidth: number;
    protected backgroundColor: string;

    // @observable
    // private audioLoadState: AudioLoadState;

    constructor(props: any, context: any) {
        super(props, context);

        this.updateSizes(this.props);
        this.backgroundColor = this.props.backgroundColor ? this.props.backgroundColor : Colors.white;
    }

    componentWillUpdate(nextProps: CategoryItemCardContainerProps) {
        this.updateSizes(nextProps);
    }

    updateSizes(props: CategoryItemCardContainerProps) {
        let sizes = calculateSizes(props.cardHeight, props.cardWidth, props.fontSize);
        this.baseStyles = sizes.baseStyles;
        this.cardHeight = sizes.height;
    }

    // Render UI
    // ------------------------------------------
    public render() {
        let backgroundColor = this.backgroundColor;
        if (this.props.isSelected !== undefined && this.props.isSelected) {
            backgroundColor = Colors.highlightYellow;
        }

        let cursor = "arrow";
        if (this.props.isSelectable !== undefined && this.props.isSelectable) {
            cursor = "pointer";
        }

        return (
            <Paper
                elevation={4}
                style={{ backgroundColor: backgroundColor, cursor: cursor }}
                children={this.renderPaperChildren()}
            />
        );
    }

    protected onBackgroundClicked = (event: any) => {
        if (event.currentTarget.id === "background") {
            if (this.props.onCardClicked !== undefined) {
                this.props.onCardClicked(event);
            }
        }
    };

    private renderPaperChildren = () => {
        return (
            <Row style={this.baseStyles.card} middle="xs">
                <Col xs={12} style={this.baseStyles.font}>
                    <div id="background" onClick={this.onBackgroundClicked}>
                        {this.props.children}
                    </div>
                </Col>
            </Row>
        );
    };
}
